import {FC, useEffect, useMemo, useState} from 'react';
//mui
import {Box} from '@mui/material';
//components
import AsideStepper from '@/components/Organization/SignUp/AsideStepper';
import FormStepper from '@/components/Organization/SignUp/FormStepper';
//constants
import {defaultStep} from '@/utils/constants';
//context
import {OrganizationSignUpContext, OrganizationSignUpContextType} from './OrganizationSignUpContext';
//styles
import {organizationSignUpStyle} from './OrganizationSignUp.styles';
import { useSearchParams } from 'react-router-dom';
import { SIGNUP_STEP } from '@/components/Organization/SignUp/FormStepper/helpers';
import { useAppSelector } from '@/store/hooks';
import { getOrganizationIdSelector } from '@/store/organization';

const STEP_PARAM_MAP: Record<string, number> = {
	form: SIGNUP_STEP.FORM,
	logo: SIGNUP_STEP.LOGO,
	payment: SIGNUP_STEP.PAYMENT,
};

const STEP_TO_PARAM: Record<number, string> = {
	[SIGNUP_STEP.FORM]: 'form',
	[SIGNUP_STEP.LOGO]: 'logo',
	[SIGNUP_STEP.PAYMENT]: 'payment',
};

const getInitialStep = (searchParams: URLSearchParams): number => {
	const stepParam = searchParams.get('step');
	return stepParam && STEP_PARAM_MAP[stepParam] !== undefined
		? STEP_PARAM_MAP[stepParam]
		: defaultStep;
};

const OrganizationSignUp: FC = () => {
		const organizationId = useAppSelector(getOrganizationIdSelector);
	
	const [searchParams, setSearchParams] = useSearchParams();

	const [activeStep, setActiveStep] = useState<number>(() => getInitialStep(searchParams));

	const nextStepHandler = (step: number) => {
		setActiveStep(step);
		setSearchParams(
			(prev) => {
				prev.set('step', STEP_TO_PARAM[step] ?? STEP_TO_PARAM[defaultStep]);
				return prev;
			},
			{ replace: true }
		);
	};

	const organizationSignUpContextValue: OrganizationSignUpContextType = useMemo(() => {
		return {
			nextStepHandler,
			activeStep,
		};
	}, [nextStepHandler, activeStep]);

	useEffect(() => {
	if ((activeStep === SIGNUP_STEP.PAYMENT || activeStep === SIGNUP_STEP.LOGO) && !organizationId) {
		nextStepHandler(SIGNUP_STEP.FORM);
	}
}, [activeStep, organizationId]);

	return (
		<OrganizationSignUpContext.Provider value={organizationSignUpContextValue}>
			<Box sx={organizationSignUpStyle.wrapper}>
				<Box sx={organizationSignUpStyle.aside}>
					<AsideStepper />
				</Box>
				<Box sx={organizationSignUpStyle.stepper}>
					<FormStepper />
				</Box>
			</Box>
		</OrganizationSignUpContext.Provider>
	);
};

export default OrganizationSignUp;
